import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import BlockButton from "../blocks/BlockButton";

export default function BlocksSidebar({ blockGroups, className = "", compact = false }) {
  const [collapsed, setCollapsed] = useState({});

  const toggle = (title) =>
    setCollapsed((prev) => ({ ...prev, [title]: !prev[title] }));

  return (
    <aside
      className={`w-64 bg-white border border-bookish-purple/12 rounded-2xl p-3 space-y-1 shadow-sm overflow-y-auto max-h-[calc(100vh-100px)] ${compact ? "max-h-none rounded-none border-0 bg-transparent p-0 shadow-none" : ""} ${className}`.trim()}
    >
      <h4 className="font-semibold text-sm px-1 pb-1 text-bookish-purple">Add Block</h4>
      {blockGroups.map((group) => (
        <div key={group.title}>
          <button
            type="button"
            onClick={() => toggle(group.title)}
            className="w-full flex items-center justify-between px-2 py-1.5 text-[11px] uppercase tracking-wider text-bookish-purple/50 hover:text-bookish-purple/80 transition-colors"
          >
            {group.title}
            <ChevronDown
              size={13}
              className={`transition-transform duration-200 ${collapsed[group.title] ? "-rotate-90" : ""}`}
            />
          </button>
          {!collapsed[group.title] && (
            <div className="space-y-1 pb-2">
              {group.items.map((item) => (
                <BlockButton key={item.label} label={item.label} onClick={item.onClick} icon={item.icon} />
              ))}
            </div>
          )}
        </div>
      ))}
    </aside>
  );
}
